import { createAsyncTypes } from 'utils/ActionCreator'

export const DATA_REQUEST_ASYNC = createAsyncTypes('DATA_REQUEST', 'ResolutionCenter/ServerScan')

export const SEARCH_CHANGE = 'ResolutionCenter/ServerScan/SEARCH_CHANGE'
export const SEARCH_RESET = 'ResolutionCenter/ServerScan/SEARCH_RESET'
export const PAGINATE_CHANGE = 'ResolutionCenter/ServerScan/PAGINATE_CHANGE'

export const statuses = ['Pending', 'Scan Started', 'Done', 'Failed', 'Canceled']
